import { render } from "./vue-file-list-item.vue?vue&type=template&id=1533267c&ts=true"
import script from "./vue-file-list-item.vue?vue&type=script&lang=ts"
export * from "./vue-file-list-item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../ss/MO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__